var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.report
      ? _c("div", [
          _vm.hasProcuration
            ? _c(
                "div",
                [
                  _c(
                    "h2",
                    [
                      _c("plain-text-control", {
                        attrs: {
                          title: "AidTargetYearlyReport.Attachments.Title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("attachment-table", {
                    staticClass: "mb-3",
                    attrs: { id: "attachments", showActions: false },
                    model: {
                      value: _vm.attachments,
                      callback: function($$v) {
                        _vm.attachments = $$v
                      },
                      expression: "attachments"
                    }
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(
                      _vm._s(_vm.$t("AidTargetYearlyReport.Profits.Title"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("line-control-component", {
                    attrs: {
                      id: "profits",
                      titleKey: "AidTargetYearlyReport.Profits.Breakdown",
                      tableKey: "AidTargetYearlyReport.Profits.Entry",
                      addButtonKey: "AidTargetYearlyReport.Profits.AddNew",
                      addButtonTooltip:
                        "AidTargetYearlyReport.Profits.AddNew_Instructions",
                      options: _vm.otherProfitOptions
                    },
                    model: {
                      value: _vm.profitsWrapper,
                      callback: function($$v) {
                        _vm.profitsWrapper = $$v
                      },
                      expression: "profitsWrapper"
                    }
                  }),
                  _vm._v(" "),
                  _vm.showGrantorsAndPurposes
                    ? _c("text-area-row", {
                        attrs: {
                          title:
                            "AidTargetYearlyReport.Profits.GrantorsAndPurposes",
                          id: "grantorsandpurposes",
                          required: true,
                          maxLength: 500,
                          rows: 7
                        },
                        model: {
                          value: _vm.profits.grantorsAndPurposes,
                          callback: function($$v) {
                            _vm.$set(_vm.profits, "grantorsAndPurposes", $$v)
                          },
                          expression: "profits.grantorsAndPurposes"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("AidTargetYearlyReport.Expenses")))
                  ]),
                  _vm._v(" "),
                  _c("personnel-expenses-control", {
                    attrs: {
                      personnelExpenses: _vm.personnelExpenses,
                      personnelExpensesWrapper: _vm.personnelExpensesWrapper,
                      features: _vm.features
                    }
                  }),
                  _vm._v(" "),
                  _c("premises-control", {
                    attrs: {
                      premises: _vm.premises,
                      applicationYear: 0,
                      createPremise: _vm.createPremiseData,
                      premiseRowHeaderKey:
                        "AidTargetYearlyReport.ColumnHeaders.Realized",
                      pathKey: "AidTargetYearlyReport"
                    }
                  }),
                  _vm._v(" "),
                  _c("line-control-component", {
                    attrs: {
                      id: "premise-expenses",
                      titleKey: "AidTargetYearlyReport.PremiseExpenses.Title",
                      tableKey:
                        "AidTargetYearlyReport.ColumnHeaders.ExpenseEntry"
                    },
                    model: {
                      value: _vm.premisesWrapper,
                      callback: function($$v) {
                        _vm.premisesWrapper = $$v
                      },
                      expression: "premisesWrapper"
                    }
                  }),
                  _vm._v(" "),
                  _c("line-control-component", {
                    attrs: {
                      id: "operational-expenses",
                      titleKey:
                        "AidTargetYearlyReport.OperationalExpenses.Breakdown",
                      tableKey:
                        "AidTargetYearlyReport.ColumnHeaders.ExpenseEntry"
                    },
                    model: {
                      value: _vm.operationalExpensesWrapper,
                      callback: function($$v) {
                        _vm.operationalExpensesWrapper = $$v
                      },
                      expression: "operationalExpensesWrapper"
                    }
                  }),
                  _vm._v(" "),
                  _vm.showGeneralExpenses
                    ? _c("general-expenses-control", {
                        attrs: {
                          generalExpenses: _vm.generalExpenses,
                          generalExpensesWrapper: _vm.generalExpensesWrapper
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("acquisitions-and-services-control", {
                    attrs: { externalServices: _vm.externalServices }
                  }),
                  _vm._v(" "),
                  _c("line-control-component", {
                    attrs: {
                      id: "totals",
                      titleKey: "AidTargetYearlyReport.Totals.Title",
                      tableKey: "AidTargetYearlyReport.Totals.Category"
                    },
                    model: {
                      value: _vm.totalsWrapper,
                      callback: function($$v) {
                        _vm.totalsWrapper = $$v
                      },
                      expression: "totalsWrapper"
                    }
                  }),
                  _vm._v(" "),
                  _vm.calculateShowAupRequired()
                    ? _c("div", {
                        staticClass: "warning-well",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "AidTargetYearlyReport.Totals.AupReportRequired"
                            )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("numeric-input-row", {
                    attrs: {
                      title:
                        "AidTargetYearlyReport.Totals.BudgetedDepositOrReceivable",
                      id: "BudgetedDepositOrReceivable",
                      required: true,
                      minValue: -1000000000
                    },
                    model: {
                      value: _vm.totals.budgetedDepositOrReceivable,
                      callback: function($$v) {
                        _vm.$set(_vm.totals, "budgetedDepositOrReceivable", $$v)
                      },
                      expression: "totals.budgetedDepositOrReceivable"
                    }
                  }),
                  _vm._v(" "),
                  _vm.showExplanationOfBudgetedAndTotalDiscrepancy()
                    ? _c("text-area-row", {
                        attrs: {
                          title:
                            "AidTargetYearlyReport.Totals.ExplanationOfBudgetedAndTotalDiscrepancy",
                          id: "ExplanationOfBudgetedAndTotalDiscrepancy",
                          maxLength: 500,
                          rows: 7,
                          required: true
                        },
                        model: {
                          value:
                            _vm.totals.explanationOfBudgetedAndTotalDiscrepancy,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.totals,
                              "explanationOfBudgetedAndTotalDiscrepancy",
                              $$v
                            )
                          },
                          expression:
                            "totals.explanationOfBudgetedAndTotalDiscrepancy"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showNextYearApplicationDeferredAmount()
                    ? _c("numeric-input-row", {
                        attrs: {
                          title:
                            "AidTargetYearlyReport.Totals.NextYearApplicationDeferredAmount",
                          id: "NextYearApplicationDeferredAmount",
                          titleParams: [_vm.report.reportYear + 1],
                          disabled: true
                        },
                        model: {
                          value: _vm.totals.nextYearApplicationDeferredAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.totals,
                              "nextYearApplicationDeferredAmount",
                              $$v
                            )
                          },
                          expression: "totals.nextYearApplicationDeferredAmount"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showExplanationOfDeferredDiscrepancy()
                    ? _c("text-area-row", {
                        attrs: {
                          title:
                            "AidTargetYearlyReport.Totals.ExplanationOfDeferredDiscrepancy",
                          id: "ExplanationOfDeferredDiscrepancy",
                          maxLength: 500,
                          rows: 7,
                          required: true
                        },
                        model: {
                          value: _vm.totals.explanationOfDeferredDiscrepancy,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.totals,
                              "explanationOfDeferredDiscrepancy",
                              $$v
                            )
                          },
                          expression: "totals.explanationOfDeferredDiscrepancy"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("text-area-row", {
                    attrs: {
                      title: "AidTargetYearlyReport.AdditionalInformation",
                      id: "additionalinformation",
                      maxLength: 500,
                      rows: 7
                    },
                    model: {
                      value: _vm.report.additionalInformation,
                      callback: function($$v) {
                        _vm.$set(_vm.report, "additionalInformation", $$v)
                      },
                      expression: "report.additionalInformation"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }